import React, { useEffect, useState } from 'react';
import {
    Radar,
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    ResponsiveContainer,
} from 'recharts';

const riskToValue = {
    HIGH: 90,
    'MEDIUM-HIGH': 75,
    MEDIUM: 60,
    NORMAL: 40,
    LOW: 20,
};

export default function Muscular({ muscleData = [], DownloadDNAreport }) {
    const [hideTicks, setHideTicks] = useState(false);


    useEffect(() => {
        const handleResize = () => {
            setHideTicks(window.innerWidth < 1050);
        };
        handleResize(); 
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const chartData = muscleData.map((item) => ({
        subject: item.Condition,
        value: riskToValue[item.Risk] || 50,
    }));

    return (
        <div>
            <div className='flex flex-col lg:flex-row items-center'>

                <div className='w-[100%] lg:w-[40%] flex items-center justify-center'>
                    <img
                        src='/assets/others/Playerinfo.svg'
                        className='h-full object-cover'
                        alt='Player info'
                    />
                </div>

                <div className='w-[100%] lg:w-[60%]'>
                    <div className='flex flex-col items-center'>
                        <ResponsiveContainer width='100%' height={400}>
                            <RadarChart outerRadius={120} data={chartData}>
                                <PolarGrid />
                                <PolarAngleAxis
                                    dataKey='subject'
                                    stroke='white'
                                    tickSize={15}
                                    tick={!hideTicks}
                                />
                                <PolarRadiusAxis angle={30} domain={[0, 100]} />
                                <Radar
                                    name='Muscular'
                                    dataKey='value'
                                    stroke='#0EA93D'
                                    fill='#0EA93D'
                                    strokeWidth={3}
                                    fillOpacity={0.6}
                                />
                            </RadarChart>
                        </ResponsiveContainer>

                        <div className='block lg:hidden'>
                            <div className='grid grid-cols-1 sm:grid-cols-3 gap-2 mt-5 w-full px-4'>
                                {chartData.map((item, index) => (
                                    <div
                                        key={index}
                                        className='p-2 text-center text-white rounded-md bg-[#0EA93D]/50'
                                    >
                                        {item.subject}: <span className='font-bold'>{item.value}%</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className='flex justify-center py-5 lg:py-0'>
                        <button onClick={() => { DownloadDNAreport() }} className='cursor-pointer py-3 w-[45%] lg:w-[20%] bg-[#A3B6FF]/40 rounded-lg font-medium'>
                            Full DNA Report
                        </button>
                    </div>

                    <div className='flex gap-3 items-center justify-end px-5 lg:px-10'>
                        <input type='checkbox' className='scale-125' />
                        Share with club
                    </div>
                </div>
            </div>
        </div>
    );
}
